<script setup>
import { i18n } from 'boot/i18n';
import { HrPageActionBtn } from 'src/design-system';

/** "+ Behavior" under a target's prompt-level list; the menu gets `prompt-levels-menu--detached`. */
const emit = defineEmits({
  add: null,
});
</script>

<template>
  <div class="row justify-end q-mt-sm">
    <!-- The one filled button in both themes; HrConfirmBtn is flat under the legacy theme. -->
    <hr-page-action-btn
      icon="add"
      :label="i18n.t('run.collectData.buttonBehavior')"
      :aria-label="i18n.t('run.collectData.buttonAddBehavior')"
      data-e2e="button-add-behavior-occurrence-prompt-level"
      @click="emit('add')"
    />
  </div>
</template>

<style>
/*
 * Not scoped — Quasar teleports the QMenu root out of the target's DOM, where scoped styles
 * cannot reach it. Dropping the menu's own card lets the prompt level list and the button read
 * as two separate floating elements; the list carries the card look instead.
 */
.prompt-levels-menu--detached {
  display: flex;
  flex-direction: column;
  background: transparent;
  box-shadow: none;
  /* Lets the list's shadow show; the list scrolls instead, keeping the button within QMenu's height cap. */
  overflow: visible;
}

.prompt-levels-menu--detached > .q-list {
  min-height: 0;
  overflow-y: auto;
}

.prompt-levels-menu--detached > :last-child {
  flex-shrink: 0;
}
</style>
